import React from "react";
import { resolveImage } from "../lib/api";

/**
 * Internal-page hero with background image + dark overlay.
 */
export const PageHero = ({ overline, title, subtitle, image, align = "left" }) => {
  return (
    <section
      className="relative overflow-hidden bg-[#0F0F10] text-white"
      data-testid={`page-hero-${(title || "").toLowerCase().replace(/\s+/g, "-")}`}
    >
      {image && (
        <div className="absolute inset-0">
          <img
            src={resolveImage(image)}
            alt=""
            className="w-full h-full object-cover opacity-35"
            loading="eager"
          />
          <div
            className={`absolute inset-0 ${
              align === "center"
                ? "bg-[#0F0F10]/70"
                : "bg-gradient-to-r from-[#0F0F10] via-[#0F0F10]/80 to-[#0F0F10]/30"
            }`}
          />
        </div>
      )}
      <div
        className={`relative max-w-7xl mx-auto px-6 md:px-10 lg:px-16 py-20 md:py-28 ${
          align === "center" ? "text-center" : ""
        }`}
      >
        {overline && (
          <div className="font-mono-sm text-xs tracking-[0.3em] uppercase text-[#E84E34] mb-4">
            // {overline}
          </div>
        )}
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight leading-[1] max-w-3xl mx-auto-none">
          {title}
        </h1>
        {subtitle && (
          <p
            className={`mt-6 text-white/70 text-lg max-w-2xl ${
              align === "center" ? "mx-auto" : ""
            }`}
          >
            {subtitle}
          </p>
        )}
      </div>
    </section>
  );
};

export default PageHero;
